import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchLetterTemplateList = ({commit}) => {

    axios.get('/letterTemplate/index.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setLetterTemplateList', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchLetterTemplateData = ({commit}, payload) => {
   
    commit('toggleLoadingState', true)
    axios.post('/letterTemplate/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            
            if(payload.copy) {
                res.data.response.id = 0
                commit('displaySuccessNotification', {message: 'Data copied!!!'});
            }
    
            commit('setLetterTemplateData', res.data.response)   
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetLetterTemplateData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitLetterTemplateData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/letterTemplate/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteLetterTemplateData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/letterTemplate/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchLetterTemplateList')
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/letterTemplate/actions.js